import InsuranceRepository from '@/shared/http/repositories/configuration/insurance'
import { mutationTypes as mutation } from './mutations'
import store from '@/store/'

const MODULE_NAME = 'insurance/insurances'
const GET_INSURANCE_BY_ID = 'getInsuranceById'
const GET_ALL_INSURANCES_BY_AREA = 'getAllInsuranceByArea'
const GET_ALL_INSURANCES_BY_AREAID = 'getAllInsuranceByAreaID'

export const actionTypes = {
  GET_INSURANCE_BY_ID,
  GET_ALL_INSURANCES_BY_AREA,
  GET_ALL_INSURANCES_BY_AREAID
}

export const actions = {
  [GET_INSURANCE_BY_ID] ({ commit }, payload) {
    commit(mutation.SET_INSURANCE, payload)
  },

  async [GET_ALL_INSURANCES_BY_AREA] ({ commit }, mnemonic, forceReload) {
    if (store.getters[MODULE_NAME].length === 0 || (forceReload)) {
      InsuranceRepository.GetAllByAreaMnemonic(mnemonic)
        .then((res) => {
          commit(mutation.SET_INSURANCES, res.data)
        })
    }
  },

  async [GET_ALL_INSURANCES_BY_AREAID] ({ commit }, areaID, forceReload) {
    if (store.getters[MODULE_NAME].length === 0 || (forceReload)) {
      InsuranceRepository.GetAllByAreaID(areaID)
        .then((res) => {
          commit(mutation.SET_INSURANCES, res.data)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/insurance/actions.js